@if (!loginDisplay) {
<section class="site-wrapper guest">
  <img class="logo" [ngClass]="{ inverted: invertedLoginColor }" [src]="partnerLogo" [alt]="partnerName" />

  <div role="presentation" class="container">
    <mat-card class="app-container-model">
      <mat-card-header>
        <mat-card-title>
          <p class="mat-body-1 gray text-center">Nice to see you again</p>
          <h1 class="mat-display-3 welcome-text">Welcome to Admin</h1>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <button class="btn btn-lg btn-primary login-button" (click)="loginRedirect()">Log in</button>
      </mat-card-content>
    </mat-card>
    <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
    @if (!isIframe) {
    <router-outlet></router-outlet>
    }
  </div>
</section>
} @if (loginDisplay) {
  <section class="site-wrapper">
    <app-header
      [invertedLoginColor]="invertedLoginColor"
      [isAuthorized]="isAuthorized"
      [isExpanded]="isExpanded"
      (mobileScreen)="setMobileView($event)"
      (notifyDesktopNavToggle)="navToggleClicked($event)"
      (notifyMobileNavToggle)="mobileNavOpen($event)"
      [attr.aria-hidden]="isModalScreen"
      [activeSecondaryNavUrl]="activeSecondaryNavUrl">
    </app-header>
  
    <main
      [ngClass]="{
        'gray-background': isModalScreen,
        guest: !isAuthorized,
        'expanded-nav': isAuthorized && isExpanded && !isMobileScreen,
        'collapsed-nav': isAuthorized && !isExpanded && !isMobileScreen,
        'secondary-nav-open': isAuthorized && isSecondaryNavOpen
      }">
      <router-outlet></router-outlet>
    </main>
  </section>
}
